/**
 * Public tournament experience service (ADR-031 P4).
 */

import * as arenaRepository from "../repositories/arenaRepository";
import { COMPETITION_STATUSES } from "../domain/competition/competitionTypes";
import { normalizeCompetitionStatus } from "../domain/competition/competitionStatusTransitions";

/**
 * @param {object | null} competition
 */
export function isCompetitionPubliclyViewable(competition) {
  if (!competition) return false;
  const status = normalizeCompetitionStatus(competition.status);
  if (status === COMPETITION_STATUSES.DRAFT) return false;
  if (status === COMPETITION_STATUSES.ARCHIVED) return false;
  if (status === COMPETITION_STATUSES.DELETED) return false;
  return true;
}

/**
 * @param {string} competitionId
 */
export async function fetchPublicCompetition(competitionId) {
  const competition = await arenaRepository.fetchCompetition(competitionId);
  if (!competition) return null;
  if (!isCompetitionPubliclyViewable(competition)) return null;
  return competition;
}

/**
 * Shareable public paths (outside AuthGate).
 */
export function publicCompetitionPath(competitionId) {
  return `/watch/${encodeURIComponent(competitionId)}`;
}

export function publicTournamentHubPath(competitionId) {
  return `${publicCompetitionPath(competitionId)}/tournament`;
}

export function publicTournamentViewPath(competitionId, drawId) {
  return `${publicTournamentHubPath(competitionId)}/${encodeURIComponent(drawId)}`;
}
